import DomainSection from "../Components/home/domain-section";
import HeroSection from "../Components/home/hero-section";
import OurProducts from "../Components/common-section/our-product";
import TechStack from "../Components/common-section/tech-stack";
import Testimonial from "../Components/common-section/testimonial";
import WhatWeDo from "../Components/home/what-we-do";
import HappyClient from "../Components/common-section/happy-client";
import MainLayout from "../layout/main-layout";
import AccrossGlobe from "../Components/AboutUs/across-globe";
import CTASection from "../Components/common-section/cta-section";
import MetaTags from "../utils/meta-tags";

function Home() {
  return (
    <div className="overflow-x-hidden">
      <MetaTags
        title="SoftCoding Solutions | Custom Web & Mobile App Development"
        description="Softcoding Solutions is a Product Engineering & Technology company helping businesses turn complex problems into scalable digital products through SaaS, AI, automation, web and mobile engineering."
        canonical="https://softcodingsolutions.com/"
        og={{
          title: "SoftCoding Solutions — Custom Web & Mobile App Development",
          description:
            "Softcoding Solutions is a Product Engineering & Technology company helping businesses turn complex problems into scalable digital products through SaaS, AI, automation, web and mobile engineering.",
          url: "https://softcodingsolutions.com/",
          type: "website",
          site_name: "SoftCoding Solutions",
          image:
            "https://softcodingsolutions.com/static/media/logo%20company.23b84ead7179e68dfe2f.png",
          imageWidth: "1200",
          imageHeight: "630",
        }}
      />
      <MainLayout>
        <HeroSection />
        <WhatWeDo />
        <OurProducts />
        <TechStack />
        <DomainSection />
        <HappyClient />
        <Testimonial />
        <CTASection />
        <AccrossGlobe />
      </MainLayout>
    </div>
  );
}

export default Home;
